import { createRootRoute, Outlet } from "@tanstack/react-router";
import { DesktopChrome } from "@/features/desktop/chrome";

export const Route = createRootRoute({
  component: () => (
    <DesktopChrome>
      <Outlet />
    </DesktopChrome>
  ),
  notFoundComponent: () => (
    <div className="grid h-full place-items-center text-[14px] text-text-2">That page does not exist.</div>
  ),
});
